import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = { class: "bg-white tw-rounded-xl tw-p-4 mb-4" }
const _hoisted_6 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_7 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "PROPERTY INFORMATION ", -1)
const _hoisted_9 = { class: "tw-px-4" }
const _hoisted_10 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_11 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TYPE OF PROPERTY ", -1)
const _hoisted_13 = {
  key: 0,
  class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_14 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ADDRESSES ", -1)
const _hoisted_20 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_21 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " FINANCING INFORMATION ", -1)
const _hoisted_23 = { class: "tw-px-4" }
const _hoisted_24 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_25 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_27 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_28 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_30 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_31 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_33 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_34 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_36 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_37 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_39 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_40 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_42 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_43 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_45 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_46 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_47 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_48 = { class: "tw-flex tw-justify-end" }
const _hoisted_49 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "MONTHLY PAYMENT ", -1)
const _hoisted_51 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CLOSING COST, BROKER AND COMMISSIONS ", -1)
const _hoisted_53 = { class: "tw-px-4" }
const _hoisted_54 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_55 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TITLE COMPANY FEES AND SERVICE PAYMENTS ", -1)
const _hoisted_57 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_58 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_60 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_61 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BUYER AGENT COMMISSION ", -1)
const _hoisted_63 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_64 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "INCOME ", -1)
const _hoisted_66 = { class: "tw-px-4" }
const _hoisted_67 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_68 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_69 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PERCENTAGE OCCUPANCY % ", -1)
const _hoisted_70 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_71 = { class: "tw-flex tw-items-center justify-content-center" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_73 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_74 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PRICE RENT FOR DAY $ ", -1)
const _hoisted_75 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_76 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_77 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE MONTHLY INCOME ", -1)
const _hoisted_78 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_79 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_80 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_81 = { class: "text-center" }
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE OF CAPITAL GAIN", -1)
const _hoisted_83 = { class: "tw-flex tw-justify-center tw-gap-[20px] tw-pb-5" }
const _hoisted_84 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_85 = { class: "tw-flex tw-justify-end" }
const _hoisted_86 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL INVESTMENT ", -1)
const _hoisted_88 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_89 = { class: "tw-flex tw-justify-end" }
const _hoisted_90 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_91 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "AVERAGE NET PROFIT OVER 5 YEARS (%) ", -1)
const _hoisted_92 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tx-center tw-h-[40px] tw-w-[150px] tw-px-3" }
const _hoisted_93 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import { ref, computed, toRefs } from 'vue';
import axios from 'axios';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { currencyFormat } from '@/composables/filters';
import { useToast } from "@/composables/useToast";
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";
import SheetShortCash from '../economicSheet/SheetShortCash.vue';
import SheetForeignShortCash from '../economicSheet/SheetForeignShortCash.vue';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ShortTermCash',
  props: {
  header: {
    type: Boolean,
    default: true,
  },
  foreign: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const toast = useToast();

// Components

const { foreign }: any = toRefs(props)
// Declare missing refs
const listPropertyTypes = ref([]);
const shortTerm = ref({
  propertyPrice: 0,
  propertyType: null,
  propertyAddress: '',
  propertyClosingCostBuy: 0,
  propertyEstimateRent: 0,
  propertyEstimateCapitalGain: 0,
  propertyAnnualNetProfit: '',
  propertyAverageNetProfitYears: '',
  propertyAssociationPaymentTax: 0,
  propertyBrokerPayment: 0,
  propertyOtherMonthlyPayment: 0,
  propertyTaxes: 0,
  propertyStateTaxes: 0,
  propertyInsurance: 0,
  propertyDownPayment: 0,
  propertyEstimateLoan: 0,
  propertyFloodInsurance: 0,
  propertyRentDay: 0,
  propertyMonthlyPercentageOccupancy: 0
});

// Existing refs
const url = environment.URL_API;
const loading = ref(false);
const scenarioValid = ref(false);
const userSession = ref(null);
const selectedMLO = ref(null);
const selectedCompanyTitle = ref(null);
const selectedInspector = ref(null);
const buyer_agents_commission = ref(0)

const customer = ref({
  name: '',
  phone: '',
  email: ''
});

// Methods
const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
};

// Computed
const companyFeesAndServices = computed(() => {
  let result = 0
  const buyer = (selectedCompanyTitle.value?.buyer || 0) / 100;
  result = shortTerm.value.propertyPrice * buyer;
  return parseFloat(result.toFixed(0))
});

const buyerAgentCommission = computed(() => {
  let result = 0
  result = (shortTerm.value.propertyPrice * (buyer_agents_commission.value / 100))
  return parseFloat(result.toFixed(0))
});

const capitalGain = computed(() => {
  let result = 0
  if (shortTerm.value.propertyType !== null) {
    result = ((shortTerm.value.propertyPrice * (shortTerm.value.propertyType.value / 100)) * 5)
  }
  return parseFloat(result.toFixed(0))
});

const totalCapitalGain = computed(() => {
  return shortTerm.value.propertyEstimateRent + capitalGain.value
});

const propertyInsurance = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * shortTerm.value.propertyInsurance / 12) / 100
  }
  return parseFloat(result.toFixed(0))
});

const propertyFloodInsurance = computed(() => {
  let result = 0
  if (shortTerm.value.propertyFloodInsurance !== 0) {
    result = (shortTerm.value.propertyFloodInsurance * shortTerm.value.propertyPrice / 12) / 100
  }
  return parseFloat(result.toFixed(0))
});

const propertyTaxes = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * shortTerm.value.propertyTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(0))
});

const federalTaxes = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * shortTerm.value.propertyStateTaxes / 12) / 100
  }
  return parseFloat(result.toFixed(0))
});

const totalMonthly = computed(() => {
  let result = 0

  result = propertyTaxes.value + federalTaxes.value + propertyInsurance.value + propertyFloodInsurance.value + shortTerm.value.propertyAssociationPaymentTax + shortTerm.value.propertyOtherMonthlyPayment

  return parseFloat(result.toFixed(0))
})

const profit = computed(() => {
  return totalCapitalGain.value - totalMonthly.value
});

const EstimateRent = computed(() => {
  let result = 0
  const days = (shortTerm.value.propertyMonthlyPercentageOccupancy / 100) * 30
  const month = days * shortTerm.value.propertyRentDay
  result = ((month * 12) * 5)
  return parseFloat(result.toFixed(0))
});

const totalIncome = computed(() => {
  let totalIncome = 0
  const FAC = 0.06
  if (shortTerm.value.propertyPrice !== null) {
    totalIncome = capitalGain.value + EstimateRent.value
  }
  return totalIncome
});

const totalExpenses = computed(() => {

  return ((propertyTaxes.value + propertyInsurance.value +
    federalTaxes.value + propertyFloodInsurance.value + shortTerm.value.propertyAssociationPaymentTax + shortTerm.value.propertyOtherMonthlyPayment) * 12) * 5
});

const netProfitPercent = computed(() => {
  console.log("income", totalIncome.value)
  console.log("expenses", totalExpenses.value)
  console.log("investment", totalInversment.value)
  console.log("resta", totalIncome.value - totalExpenses.value)
  console.log("division", (totalIncome.value - totalExpenses.value) / totalInversment.value)
  console.log("-----------------------------------------------------------")
  const result = ((totalIncome.value - totalExpenses.value) / totalInversment.value) * 100
  return result > 0 ? (result).toFixed(0) : 0
});

const totalInversment = computed(() => {
  if (shortTerm.value.propertyPrice !== 0 && selectedCompanyTitle.value !== null) {
    return shortTerm.value.propertyBrokerPayment + companyFeesAndServices.value + shortTerm.value.propertyPrice + buyerAgentCommission.value
  }
});

const monthlyPercentageOccupancyValue = computed(() => {
  if (shortTerm.value.propertyMonthlyPercentageOccupancy) {
    return (shortTerm.value.propertyMonthlyPercentageOccupancy / 100) * (365 / 12);
  }
  return null;
});

const estimateMonthlyIncome = computed(() => {
  if (shortTerm.value.propertyRentDay && monthlyPercentageOccupancyValue.value) {
    return shortTerm.value.propertyRentDay * monthlyPercentageOccupancyValue.value;
  }
  return null;
});

const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    shortTerm.value.propertyBrokerPayment = response.data.commissions.real_estate_broker_fee || 0;
    listPropertyTypes.value = [{
      name: 'TOWN HOUSE',
      value: response.data.annualAverageCapitalGain.town_house || 0,
    },
    {
      name: 'CONDO',
      value: response.data.annualAverageCapitalGain.condo || 0,
    },
    {
      name: 'SINGLE HOUSE',
      value: response.data.annualAverageCapitalGain.single_house || 0,
    },
    {
      name: 'VILLA',
      value: response.data.annualAverageCapitalGain.villa || 0,
    },
    {
      name: 'MOBILE',
      value: response.data.annualAverageCapitalGain.mobile || 0,
    },
    {
      name: 'OTHERS',
      value: response.data.annualAverageCapitalGain.others || 0,
    }];
    if (response.data.averageTaxesAndInsurance) {
      shortTerm.value.propertyTaxes = response.data.averageTaxesAndInsurance.property_taxes
      shortTerm.value.propertyInsurance = response.data.averageTaxesAndInsurance.property_insurance
      shortTerm.value.propertyFloodInsurance = response.data.averageTaxesAndInsurance.property_flood_insurance
      shortTerm.value.propertyStateTaxes = response.data.averageTaxesAndInsurance.federal_taxes
    }
    if (response.data.commissions) {
      buyer_agents_commission.value = response.data.commissions.buyer_agent_commission
    }
  }
  loading.value = false;
};

// Add missing methods
const calculatePropertyEstimateCapitalGain = () => {
  const price = shortTerm.value.propertyPrice || 0;
  const typeMultiplier = shortTerm.value.propertyType.value || 0;
  shortTerm.value.propertyEstimateCapitalGain = ((price * typeMultiplier) / 100) * 5;
};

// const calculateProperty = (type: string) => {
//   switch (type) {
//     case 'monthlytaxes':
//       shortTerm.value.propertyMonthlyPropertyTaxes =
//         shortTerm.value.propertyAnnualPropertyTaxes ?
//           shortTerm.value.propertyAnnualPropertyTaxes / 12 : 0;
//       break;
//     case 'estimated':
//       shortTerm.value.propertyMonthlyPropertyInsurance =
//         shortTerm.value.propertyAnnualPropertyInsurance ?
//           shortTerm.value.propertyAnnualPropertyInsurance / 12 : 0;
//       break;
//     case 'monthlystatetaxes':
//       shortTerm.value.propertyMonthlyStateTaxes =
//         shortTerm.value.propertyAnnualStateTaxes ?
//           shortTerm.value.propertyAnnualStateTaxes / 12 : 0;
//       break;
//     case 'monthlyfederaltaxes':
//       shortTerm.value.propertyMonthlyFederalTaxes =
//         shortTerm.value.propertyAnnualFederalTaxes ?
//           shortTerm.value.propertyAnnualFederalTaxes / 12 : 0;
//       break;
//   }
// };

const submitScenario = async () => {
  loading.value = true;
  if (!foreign.value) {
    const response = await axios(`${url}realtor-short-cash`, {
      method: "POST",
      data: {
        realtorShortCash: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "SHORT CASH",
          propertyType: shortTerm.value.propertyType?.value,
          propertyadresses: shortTerm.value.propertyAddress,
          propertyPrice: shortTerm.value.propertyPrice,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: shortTerm.value.propertyAssociationPaymentTax,
          otherMonthlyPayment: shortTerm.value.propertyOtherMonthlyPayment,
          monthlyPayment: totalMonthly.value,
          companyFeesAndServices: companyFeesAndServices.value,
          brokerPayment: shortTerm.value.propertyBrokerPayment,
          buyerAgentComission: buyerAgentCommission.value,
          monthlypercentage: shortTerm.value.propertyMonthlyPercentageOccupancy,
          priceForDay: shortTerm.value.propertyRentDay,
          estimateIncome: estimateMonthlyIncome.value,
          capitalGain: capitalGain.value,
          totalInvestment: totalInversment.value,
          averageNet: netProfitPercent.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "SHORT CASH",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },

      }

    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } else {
    const response = await axios(`${url}realtor-short-cash`, {
      method: "POST",
      data: {
        realtorShortCash: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN SHORT CASH",
          propertyType: shortTerm.value.propertyType?.value,
          propertyadresses: shortTerm.value.propertyAddress,
          propertyPrice: shortTerm.value.propertyPrice,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: shortTerm.value.propertyAssociationPaymentTax,
          otherMonthlyPayment: shortTerm.value.propertyOtherMonthlyPayment,
          monthlyPayment: totalMonthly.value,
          companyFeesAndServices: companyFeesAndServices.value,
          brokerPayment: shortTerm.value.propertyBrokerPayment,
          buyerAgentComission: buyerAgentCommission.value,
          monthlypercentage: shortTerm.value.propertyMonthlyPercentageOccupancy,
          priceForDay: shortTerm.value.propertyRentDay,
          estimateIncome: estimateMonthlyIncome.value,
          capitalGain: capitalGain.value,
          totalInvestment: totalInversment.value,
          averageNet: netProfitPercent.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN SHORT CASH",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },

      }

    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  }
}

const updateParentCompanyTitle = (newCompanyTitle: any) => {
  selectedCompanyTitle.value = newCompanyTitle;
};

const updateParentInspector = (newInspector: any) => {
  selectedInspector.value = newInspector;
};

// Initialize component
getSession();
getRealtorForm();

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(foreign))
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial",
          helpVideo: "https://www.realtortools.org/media/Video%20Short%20Term%20Cash.mp4"
        }))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ResidentialView, { header: false })
        ]))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(foreign))
        ? (_openBlock(), _createBlock(SheetShortCash, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(foreign))
        ? (_openBlock(), _createBlock(SheetForeignShortCash, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(FindA, {
        userSession: userSession.value,
        selectedCompanyTitle: selectedCompanyTitle.value,
        usingInspector: selectedInspector.value,
        isInvestment: true,
        "onUpdate:selectedCompanyTitle": updateParentCompanyTitle,
        "onUpdate:usingInspector": updateParentInspector
      }, null, 8, ["userSession", "selectedCompanyTitle", "usingInspector"]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(MLO, {
          title: "CASH SHORT TERM INVESTMENT",
          userSession: userSession.value,
          usingMLO: selectedMLO.value,
          "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
          customer: customer.value,
          hiddeMLO: true
        }, null, 8, ["userSession", "usingMLO", "customer"])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_11, [
                  _hoisted_12,
                  (listPropertyTypes.value.length > 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("select", {
                            name: "",
                            id: "",
                            class: "form-control tw-full",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((shortTerm.value.propertyType) = $event)),
                            onChange: calculatePropertyEstimateCapitalGain
                          }, [
                            _hoisted_15,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPropertyTypes.value, (property) => {
                              return (_openBlock(), _createElementBlock("option", { value: property }, _toDisplayString(property.name), 9, _hoisted_16))
                            }), 256))
                          ], 544), [
                            [_vModelSelect, shortTerm.value.propertyType]
                          ]),
                          (shortTerm.value.propertyType)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                value: (shortTerm.value.propertyType.value ? shortTerm.value.propertyType.value + '%' : ''),
                                disabled: ""
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("tr", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("td", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shortTerm.value.propertyAddress) = $event))
                    }, null, 512), [
                      [_vModelText, shortTerm.value.propertyAddress]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("table", _hoisted_24, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPrice",
                      value: shortTerm.value.propertyPrice,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((shortTerm.value.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                      onChange: calculatePropertyEstimateCapitalGain
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_28, [
                  _hoisted_29,
                  _createElementVNode("td", _hoisted_30, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: propertyTaxes.value,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((propertyTaxes).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_31, [
                  _hoisted_32,
                  _createElementVNode("td", _hoisted_33, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: propertyInsurance.value,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((propertyInsurance).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("td", _hoisted_36, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: federalTaxes.value,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((federalTaxes).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_37, [
                  _hoisted_38,
                  _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(currencyFormat)(propertyFloodInsurance.value)), 1)
                ]),
                _createElementVNode("tr", _hoisted_40, [
                  _hoisted_41,
                  _createElementVNode("td", _hoisted_42, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "association",
                      value: shortTerm.value.propertyAssociationPaymentTax,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((shortTerm.value.propertyAssociationPaymentTax) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("td", _hoisted_45, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "otherMontlhyPayment",
                      value: shortTerm.value.propertyOtherMonthlyPayment,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((shortTerm.value.propertyOtherMonthlyPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createVNode(_unref(VueNumberFormat), {
                  id: "association",
                  value: totalMonthly.value,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((totalMonthly).value = $event)),
                  options: {
                  precision: 0,
                  prefix: '$ ',
                  thousand: ',',
                  acceptNegative: false,
                  isInteger: false,
                  decimal: '.',
                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("table", _hoisted_54, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_55, [
                  _hoisted_56,
                  _createElementVNode("td", _hoisted_57, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: companyFeesAndServices.value,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((companyFeesAndServices).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_58, [
                  _hoisted_59,
                  _createElementVNode("td", _hoisted_60, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: shortTerm.value.propertyBrokerPayment,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((shortTerm.value.propertyBrokerPayment) = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_61, [
                  _hoisted_62,
                  _createElementVNode("td", _hoisted_63, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: buyerAgentCommission.value,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((buyerAgentCommission).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_64, [
          _hoisted_65,
          _createElementVNode("div", _hoisted_66, [
            _createElementVNode("table", _hoisted_67, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_68, [
                  _hoisted_69,
                  _createElementVNode("td", _hoisted_70, [
                    _createElementVNode("div", _hoisted_71, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((shortTerm.value.propertyMonthlyPercentageOccupancy) = $event))
                      }, null, 512), [
                        [_vModelText, shortTerm.value.propertyMonthlyPercentageOccupancy]
                      ]),
                      _hoisted_72
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_73, [
                  _hoisted_74,
                  _createElementVNode("td", _hoisted_75, [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "propertyRentDay",
                        value: shortTerm.value.propertyRentDay,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((shortTerm.value.propertyRentDay) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_76, [
                  _hoisted_77,
                  _createElementVNode("td", _hoisted_78, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyEstimateMonthlyIncome",
                      value: estimateMonthlyIncome.value,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((estimateMonthlyIncome).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, [
              _createElementVNode("div", _hoisted_81, [
                _hoisted_82,
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyEstimateCapitalGain",
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5",
                  value: capitalGain.value,
                  "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((capitalGain).value = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_83, [
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              _createElementVNode("div", _hoisted_86, [
                _hoisted_87,
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyEstimateInvestment",
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tx-center tw-h-[40px] tw-w-[150px] tw-px-3",
                  value: totalInversment.value,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((totalInversment).value = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_88, [
            _createElementVNode("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _hoisted_91,
                _createElementVNode("div", _hoisted_92, _toDisplayString(netProfitPercent.value) + " % ", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_93, [
          _createElementVNode("button", {
            onClick: _cache[18] || (_cache[18] = ($event: any) => (submitScenario())),
            class: "tw-bg-[#78c18a] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER")
        ])
      ])
    ])
  ]))
}
}

})